import React from "react";

import {
  MdLocalOffer,
  MdCheckCircle,
  MdCancel,
  MdPeople,
} from "react-icons/md";

import TableActions from "../../components/table/TableActions";

const badgeStyle = {
  padding: "8px 16px",
  borderRadius: "999px",
  fontSize: 12,
  fontWeight: 700,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
};

const formatDate = (timestamp) => {

  if (!timestamp) return "-";

  try {

    return timestamp
      .toDate()
      .toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

  } catch {

    return "-";

  }

};

export const couponColumns = ({
  onView,
}) => [

  /* ==========================================
      COUPON
  ========================================== */

  {
    key: "coupon",

    title: "Coupon",

    render: (coupon) => (

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 15,
          minWidth: 250,
        }}
      >

        <div
          style={{
            width: 58,
            height: 58,
            borderRadius: 16,
            background: "#EEF2FF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#4F46E5",
            fontSize: 28,
          }}
        >

          <MdLocalOffer />

        </div>

        <div>

          <div
            style={{
              fontWeight: 700,
              fontSize: 15,
            }}
          >
            {coupon.code}
          </div>

          <div
            style={{
              color: "#6B7280",
              fontSize: 13,
            }}
          >
            {coupon.title}
          </div>

        </div>

      </div>

    ),

  },

  /* ==========================================
      REWARD
  ========================================== */

  {
    key: "reward",

    title: "Reward",

    render: (coupon) => (

      <span
        style={{
          ...badgeStyle,
          background: "#EEF2FF",
          color: "#4338CA",
        }}
      >

        +{coupon.rewardValue}

        {" "}

        {coupon.rewardType}

      </span>

    ),

  },

  /* ==========================================
      USES
  ========================================== */

  {
    key: "uses",

    title: "Uses",

    render: (coupon) => (

      <span
        style={{
          ...badgeStyle,
          background: "#F9FAFB",
          color: "#374151",
        }}
      >

        <MdPeople />

        {coupon.usedCount || 0}

        /

        {coupon.maxUses}

      </span>

    ),

  },

  /* ==========================================
      EXPIRY
  ========================================== */

  {
    key: "expiry",

    title: "Expiry",

    render: (coupon) =>

      formatDate(
        coupon.expiryDate
      ),

  },

  /* ==========================================
      STATUS
  ========================================== */

  {
    key: "status",

    title: "Status",

    render: (coupon) => {

      const active =
        coupon.active === true;

      return (

        <span
          style={{
            ...badgeStyle,

            background: active
              ? "#DCFCE7"
              : "#FEE2E2",

            color: active
              ? "#15803D"
              : "#B91C1C",
          }}
        >

          {active ? (

            <MdCheckCircle />

          ) : (

            <MdCancel />

          )}

          {active
            ? "Active"
            : "Inactive"}

        </span>

      );

    },

  },

  /* ==========================================
      ACTIONS
  ========================================== */

  {
    key: "actions",

    title: "Actions",

    render: (coupon) => (

      <TableActions

        row={coupon}

        onView={onView}

      />

    ),

  },

];